import script from "./CasesAccepted.vue?vue&type=script&setup=true&lang=ts"
export * from "./CasesAccepted.vue?vue&type=script&setup=true&lang=ts"

import "./CasesAccepted.vue?vue&type=style&index=0&id=0f2df1f0&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f2df1f0"]])

export default __exports__